import axios from "axios";
import { useEffect, useState } from "react";
import { createContext, useContext } from "react";
import React from 'react'
import { ToastContainer, toast } from 'react-toastify';


const initialState = {
    isLoading: false,
    postList: [],
    error: null,
    message: null
 }
const PostContext = createContext(initialState);

const PostAppProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [postList, setPostList] = useState([]);
    const [error,setError]=useState('');
    const [message,setMessage]=useState('')
 
    const handleMakeAPICall = async () => {
        setIsLoading(true);
        const url = "https://jsonplaceholder.typicode.com/posts"
        await axios.get(url).then((res) => {
           setPostList(res.data);
           setMessage("Posts are displayed Successfully!")
           toast.success("Displayed Successfully!")
        }).catch((err) => {
          setError(err)
          toast.error(`Error:${err}`)
        }).finally(()=>{
          setIsLoading(false);   
        })
    }

    useEffect(()=>{
       handleMakeAPICall();
    },[])
    return (
        <PostContext.Provider value={{
            isLoading,
            setIsLoading,
            error,
            setError,
            message,
            setMessage,
            postList,
            handleMakeAPICall
        }}>
            {children}
        </PostContext.Provider>
    )
}

const usePostsDataContext=()=>{
    return useContext(PostContext)
}
export {PostContext,PostAppProvider,usePostsDataContext}